define('bat',[
  'jquery',
  'lib/util/tda.config',
  'storageUtil',
  // side effect includes
  'Handlebars'
], function (
  $,
  tdaConfig,
  storageUtil
) {
  window.bat = $.extend(window.bat || {}, {
    util: {
      hcompile: function (template, data) {
        var tmpl;
        if (template && data) {
          tmpl = template.replace('<![CDATA[', '')
            .replace(']]>', '')
            .replace('//<![CDATA[', '')
            .replace('//]]>', '');
          return Handlebars.compile(tmpl)(data);
        }
        return '';
      },

      /*
       * escape special chars from jquery selectors
       * https://learn.jquery.com/using-jquery-core/faq/how-do-i-select-an-element-by-an-id-that-has-characters-used-in-css-notation/
       */
      jqStrip: function (myid) {
        return myid.replace(/(:|\.|\[|\])/g, '\\$1');
      },

      loader: {
        showLoader: function () {
          $('#main-wrapper-row').addClass('show-loader');
          $('#main-wrapper-row').removeClass('hide-loader');
        },

        /*
        Usually invoked via Zip process (if unconfirmed zip).
        page based hideloader = hideloader(true);
        ugly hack - if this is the vehicle page, dont hideloader until we
        we do it later on in vehicle-info.js
        */
        hideLoader: function (pageBased, immediately, time) {
          if (immediately && !time) {
            $('#main-wrapper-row').removeClass('show-loader').addClass('hide-loader-now');
            return;
          }

          if (immediately && time) {
            setTimeout(function () {
              $('#main-wrapper-row').removeClass('show-loader').addClass('hide-loader');
            }, time);
            return;
          }

          setTimeout(function () {
            $('#main-wrapper-row').removeClass('show-loader').addClass('hide-loader');
          }, 1600);
        }
      }
    }
  });

  // Keeping the Handlebars-namespaced shim in place for backward compatibility
  // Please use bat.hcompile() if possible
  // Extend handlebars to allow cdata in script tags and return function with data passed at compile time
  window.bat.hcompile = window.bat.util.hcompile;
  window.Handlebars.hcompile = window.bat.hcompile;

  // random global taints
  window.bat.OFFER_DETAIL_MODAL = {}; // from ajax-offers.js

  // BAT-3014 FORMATS LINK NUMBERS TO BE NUMBERS ONLY, ADD 1 AT TOP IF NEEDED.
  window.bat.formatPhoneLink = function (pn) {
    pn = pn.replace(/[^0-9]/g, '');
    if (pn.charAt(0) !== '1') {
      pn = '1' + pn;
    }
    return pn;
  };

  window.bat.updateSETLinks = function () {
    $.map($('a'), function (link) {
      if (String(link.href).indexOf('tab=helpful-resources&tool=black-book') === -1) {
        if (String(link.href).indexOf('southeast.buyatoyota.com') != -1) {
          if (String(link.href).indexOf('originating_zip_code') == -1) {
            if (String(link.href).indexOf('?') == -1) {
              link.href = link.href + '?originating_zip_code=' + storageUtil.getZip();
            } else {
              link.href = link.href + '&originating_zip_code=' + storageUtil.getZip();
            }
          } else {
            var pattern = /originating_zip_code.\d+/;
            link.href = link.href.replace(pattern, 'originating_zip_code=' + storageUtil.getZip());
          }
        }
      }
    });
  };

  /*----------------------------------------------------------------------------------------
  Used to see if a dealer that uses contactatonce.com service is currently online
  returns a resolved promise obj with an obj of data as the response.
  NOTE: this is a JSONP request, so the usual .done(), .fail() can NOT be used
  instead, we use timeout which will invoke the error method if there's an issue retrieving the JSONP file
  Also note: this is used ONLY for 'Click to Chat', not for 'Text Your Local Dealership'

  providerId = tdaConfig.chat.provider_id
  merchantId = dealer_code
  whereToDisplay = 'dealerdetailchat', 'dealerresultschat', 'dealercomponentchat', 'offerdetailchat'
  These are configured in TDA_config within Teamsite
  TODO: move outta here
  ----------------------------------------------------------------------------------------*/
  window.bat.dealerChatPresence = function (providerIdAccount, merchantIdAccount, whereToDisplay) {
    var providerId = providerIdAccount || false;
    var merchantId = merchantIdAccount || false;
    var deferredChatPresenceObj = $.Deferred();
    var $dealerDataDom = $('#defaultzipcode'); // this DOM element contains contactatonce data and data that the TDA sets in the TOOLS DCR
    var tdaClickToChat = {
      isOnline: false,
      showOnDealerDetailPage: true, // No longer check toggle, just if CTA is present via TOOLS DCR
      showOnDealerResultsPage: true, // No longer check toggle, just if CTA is present via TOOLS DCR
      showOnDealerComponent: false
    };

    // Dealer component, relies on the toggle in TDA_config still!!
    if ($dealerDataDom.attr('dealercomponentchat') === 'Yes') {
      tdaClickToChat.showOnDealerComponent = true;
    }
    // if there's no providerId OR merchantID configured on this TDA
    // there's no reason to go any further, just respond with the
    // default tdaClickToChat obj, since we won't be displaying any Contact at once CTAs
    if (!providerId || !merchantId) {
      deferredChatPresenceObj.resolve(tdaClickToChat);
      return false;
    }

    if (whereToDisplay === 'dealerdetailchat' && tdaClickToChat.showOnDealerDetailPage
      || whereToDisplay === 'dealerresultschat' && tdaClickToChat.showOnDealerResultsPage
      || whereToDisplay === 'dealercomponentchat' && tdaClickToChat.showOnDealerComponent
      || whereToDisplay === 'offerdetailchat') {
      // console.group('COA global.js, in dealerChatPresence, just before call to jsonp.contactatonce ajax');
      // console.groupEnd();
      // BAT 2915, if this is KAC (BOS10 for testing) then we do NOT need to move fwd
      if (tdaConfig.tda.code === 'KAC10') {
        tdaClickToChat.isOnline = true;
        deferredChatPresenceObj.resolve(tdaClickToChat);
      } else {
        $.ajax({
          url: '//jsonp.contactatonce.com/PresencePostback.aspx?ProviderID=' + providerId + '&MerchantId=' + merchantId,
          data: {
            format: 'json'
          },
          dataType: 'jsonp',
          timeout: 5000,
          type: 'GET',
          success: function (response) {
            if (response.presenceStatus === 'online') {
              tdaClickToChat.isOnline = true;
            } else {
              tdaClickToChat.isOnline = false;
            }
            // resolve promise and pass along our final tdaClickToChat obj
            deferredChatPresenceObj.resolve(tdaClickToChat);
            // console.group('COA global.js, in dealerChatPresence ajax success');
            // 	console.log('deferredChatPresenceObj.state: ', deferredChatPresenceObj.state());
            // console.groupEnd();
          },
          error: function (error) {
            deferredChatPresenceObj.resolve(tdaClickToChat);
            // console.group('COA global.js, in dealerChatPresence ajax error');
            // 	console.log('jsonp.contactatonce.com timed out: ', error);
            // 	console.log('deferredChatPresenceObj.state: ', deferredChatPresenceObj.state());
            // console.groupEnd();
          }
        });
      }
    } else {
      // if no ajax call is needed we still need to:
      // resolve promise and pass along our final tdaClickToChat obj
      deferredChatPresenceObj.resolve(tdaClickToChat);
      // console.group('COA global.js, in dealerChatPresence. NO AJAX call was needed');
      // console.log('deferredChatPresenceObj.state: ', deferredChatPresenceObj.state());
      // console.groupEnd();
    }

    return deferredChatPresenceObj.promise();
  };


  /*
  from all-offers.js, use to live directly on window.finPrintDetail.
  // invoked via offers-iframe.xsl
  */
  window.bat.fnPrintDetail = function () {
    function formatDateTime(date) {
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0' + minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm.toUpperCase();
      return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear() + ' ' + strTime;
    }
    var d = new Date();
    var e = formatDateTime(d);
    var cashText = '';
    var offerText = '';
    var bulletText = '';
    var callText = '';
    var disclaimerText = '';
    var imageText = '';
    var modalTitle = $('.modal-title').text();
    var leaseText = '';
    if ($('.vehicle-img-wrap').find('.marg-bottom-4-sm').find('.marg-bottom-4-sm').html() != 'undefined' && $('.vehicle-img-wrap').find('.marg-bottom-4-sm').find('.marg-bottom-4-sm').html() != null && $('.vehicle-img-wrap').find('.marg-bottom-4-sm').find('.marg-bottom-4-sm').html() != '' && $.trim($('.vehicle-img-wrap').find('.marg-bottom-4-sm').find('.marg-bottom-4-sm').html()) != '' && typeof $('.vehicle-img-wrap').find('.marg-bottom-4-sm').find('.marg-bottom-4-sm').html() !== 'undefined') {
      cashText = '<span style="margin-left:200px">' + $('.vehicle-img-wrap').find('.marg-bottom-4-sm').find('.marg-bottom-4-sm').html() + '</span>';
    }
    if ($('.marg-bottom-6-sm').html() != 'undefined' && $('.marg-bottom-6-sm').html() != null && $('.marg-bottom-6-sm').html() != '' && $.trim($('.marg-bottom-6-sm').html()) != '' && typeof $('.marg-bottom-6-sm').html() !== 'undefined') {
      offerText = '<span style="margin-left:200px">' + $('.marg-bottom-6-sm').html() + '</span>';
    }
    if ($('.col-md-5').html() != 'undefined' && $('.col-md-5').html() != null && $('.col-md-5').html() != '' && $.trim($('.col-md-5').html()) != '' && typeof $('.col-md-5').html() !== 'undefined') {
      bulletText = '<div style="margin-left:20px">' + $('.col-md-5').html() + '</div>';
    }

    // Lease offers
    if (modalTitle != 'undefined' && modalTitle != null && modalTitle != '' && modalTitle != '' && typeof modalTitle !== 'undefined' && modalTitle.indexOf('lease') != -1) {
      leaseText = '<div id="offer-detail" style="margin-left:200px">' + $('.vehicle-img-wrap').children().children('.col-sm-12').html() + '</div>';
      // NCA-232, drop cashText, since it's already included within leaseText
      cashText = '';
    }
    if ($('.offer-detail-modal-cta').parent('div').html() != 'undefined' && $('.offer-detail-modal-cta').parent('div').html() != null && $('.offer-detail-modal-cta').parent('div').html() != '' && $.trim($('.offer-detail-modal-cta').parent('div').html()) != '' && typeof $('.offer-detail-modal-cta').parent('div').html() !== 'undefined') {
      callText = '<div style="margin-left:20px">' + $('.offer-detail-modal-cta').parent('div').html() + '</div>';
    }

    if ($('.disclaimers-panel').html() != 'undefined' && $('.disclaimers-panel').html() != null && $('.disclaimers-panel').html() != '' && $.trim($('.disclaimers-panel').html()) != '' && typeof $('.disclaimers-panel').html() !== 'undefined') {
      disclaimerText = '<br/><div style="margin-left:10px"><div class="col-md-12 marg-top-4-sm font--1 color-lightest text-left"><strong>Disclaimers</strong></div>' + $('.disclaimers-panel').html() + '</div>';
    }

    if ($('.valign-middle-md').find('img').attr('src') != 'undefined' && $('.valign-middle-md').find('img').attr('src') != null && $('.valign-middle-md').find('img').attr('src') != '' && $.trim($('.valign-middle-md').find('img').attr('src')) != '' && typeof $('.valign-middle-md').find('img').attr('src') !== 'undefined') {
      imageText = '<div style="margin-left:150px"><img src="' + $('.valign-middle-md').find('img').attr('src') + '"></img></div>';
    }
    var newWindow = window.open('', 'print_detail', 'width=800,height=800,scrollbars=1,resizable=1');
    var html = '<!DOCTYPE html><html><head><META http-equiv="Content-Type" content="text/html; charset=UTF-8"><title>Toyota Dealer Association Offers Frame</title><link href="/assets/css/all.css" rel="stylesheet" type="text/css"><style>body{margin-left: 20px !important;}.disclaimers-link{display:none !important}</style></head><body><div id="" style="width: 950px; height: 60px; background-image: url(http://www.cincinnati.buyatoyota.com/img/landing/dealer_offers_frame/headerBG.jpg); background-repeat: repeat-x;" class=""><span><p><img height="60" width="456" alt="Frame Banner" src="http://www.cincinnati.buyatoyota.com/img/landing/dealer_offers_frame/movingForwardLogo.jpg" title="Toyota Page Banner"></p></span></div><p><span style="color: #9a0f14; font-family: Verdana, Geneva, sans-serif; font-size: 24px; font-style: normal; font-variant: normal; font-weight: bold; letter-spacing: normal; line-height: normal; orphans: auto; text-align: start; text-indent: 0px; text-transform: none; white-space: normal; widows: auto; word-spacing: 0px; -webkit-text-stroke-width: 0px; display: inline !important; float: none;">TOYOTA SPECIAL OFFERS</span></p><div style="margin-left:20px"><h2 class="modal-title font-bold">' + $('.modal-title').text() + '</h2><div>Printed - <span id="curr_time">' + e + '</span></div>' + $('.text-right-md').html() + '</div><br style="clear:both"><br style="clear:both"><br style="clear:both">' + offerText + '<br style="clear:both"><br style="clear:both">' + leaseText + cashText + imageText + bulletText + callText + disclaimerText;
    newWindow.document.open();
    newWindow.document.write(html);
    newWindow.document.close();
    setTimeout(function () {
      newWindow.print();
    }, 1500);
  };

  // make sure require is referencing the global window.bat object if used elsewhere
  return window.bat;
});

